import React from 'react';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import CreditToolsModuleView from 'customCreditToolsModulePath/CreditToolsModuleView';
import { useSelector } from 'react-redux';
import { getCardModule } from 'helpers/offer.helpers';
import { useScoreSimulatorExp } from 'pages_ScoreSimulator_hooks/ScoreSimulatorExp.hook';
import { useCreditTools } from 'partial/OfferManager/modules/CreditToolsModule/hooks/creditTools.hoook';

const countNewAlerts = alerts => {
  if (alerts) {
    const filterNewAlerts = alerts.filter(alert => alert.viewed === false);

    const newAlerts =
      filterNewAlerts.length !== 0 ? filterNewAlerts.length : 'No';
    return newAlerts;
  }
};

const CreditToolsModuleController = props => {
  const { userInfo, cashAccount, history, eventHandler } = props;
  const {
    cmAlerts,
    profileContainer,
    csidAlerts,
    notification: userNotifications,
    dateOfLastCreditReport,
  } = useSelector(state => ({
    cmAlerts: state?.cmAlerts?.cmAlerts?.items,
    profileContainer: state?.profileContainer?.profileContainer,
    csidAlerts: state?.csidAlerts?.csidAlerts?.items,
    notification: state?.notification,
    dateOfLastCreditReport:
      state?.creditReport?.creditReports?.items?.[0]?.createDate,
  }));

  const { onClickCreditTools, goToPremium } = useCreditTools({
    userInfo,
    cashAccount,
    history,
    eventHandler,
  });

  const newAlertsCreditMonitoring = countNewAlerts(cmAlerts);
  const newCsidAlerts = countNewAlerts(csidAlerts);
  const bureauScoreDetails = getCardModule(
    profileContainer,
    'ALL_BUREAU_SCORE_DIALS',
  )?.additionalData;

  const scoreSimulatorExp = useScoreSimulatorExp();

  const loading = props.globalLoadingFlag;

  if (loading) {
    return <PageLoadingMask description={'Loading...'} />;
  } else {
    return (
      <CreditToolsModuleView
        userInfo={userInfo}
        userNotifications={userNotifications}
        cashAccount={cashAccount}
        history={history}
        newAlertsCreditMonitoring={newAlertsCreditMonitoring}
        bureauScoreDetails={bureauScoreDetails}
        newCsidAlerts={newCsidAlerts}
        modulePosition={props.modulePosition}
        eventHandler={eventHandler}
        scoreSimulatorEnabled={scoreSimulatorExp?.enabled}
        className={props.className}
        onClickCreditTools={onClickCreditTools}
        goToPremium={goToPremium}
        dateOfLastCreditReport={dateOfLastCreditReport}
        isDesktopCarouselView={props.isDesktopCarouselView}
      />
    );
  }
};

export default CreditToolsModuleController;
